












import { defineComponent, onMounted, ref, useContext, useFetch } from '@nuxtjs/composition-api'
import { useContent } from '~/composables';
import { getAsJSON } from '~/utils/solepro/CmsComponentAggregator';
import OfferBlock from './OfferBlock.vue';
import Spinner from '~/components/solepro/Spinner.vue';
import EmptyBlock from './EmptyBlock.vue';

export default defineComponent({
    components: {
        OfferBlock,
        Spinner,
        EmptyBlock
    },
    setup() {

        const { loadBlocks } = useContent();
        const offers = ref([]);
        const loading = ref(true)
        const context = useContext();

        onMounted(async () => {
            const offersContent = await loadBlocks({ identifiers: ['solepro_myaccount_offers'] });
            try {
                const offersJson = getAsJSON(offersContent[0].content, false, !!context.isDev).children;
                offers.value = offersJson.filter(n => n.cssClasses.includes('my-account-offer'));
                loading.value = false
            } catch (e) {
                console.error('Error parsing offers content', e)
                loading.value = false
            }
        })

        return {
            offers,
        }
    },
    mounted() {
        //console.log(this.offers)
    }
})
